import React, { ReactElement } from 'react';
import { Button, Modal } from 'react-bootstrap';
import backgroundConfirmModal from '../../../../assets/png/ic_dialog_loginbonus_mission.png';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import {
  toggleConfirmGiftMissionModal,
  updateListMissionConfirm,
} from './LiveMissionSlice';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import './LiveMissionConfirmGiftModal.scss';

const LiveMissionConfirmGiftModal = (): ReactElement => {
  const dispatch = useDispatch();
  const { isShowConfirmModal, listMissionConfirm } = useSelector(
    (state: AppState) => state.liveMission,
  );

  const handleCloseModal = () => {
    dispatch(updateListMissionConfirm([]));
    dispatch(toggleConfirmGiftMissionModal(false));
  };
  const renderItem = () => {
    if (listMissionConfirm && listMissionConfirm.length === 1) {
      return (
        <>
          {listMissionConfirm?.map((mission) => (
            <div style={{ margin: '40px' }} key={mission.id}>
              <div
                className="mission-item__thumbnail"
                style={{ margin: 'auto', marginBottom: '40px' }}
              >
                <ImageCustom src={mission.prizeResourceUri} />
              </div>
              <div className="mission-confirm-modal__title">
                ギフトを贈ってライバーを応援しよう！
              </div>
            </div>
          ))}
        </>
      );
    }
    if (listMissionConfirm && listMissionConfirm.length > 1) {
      return (
        <div style={{ margin: '40px' }}>
          <div
            style={{ marginBottom: '40px' }}
            className="mission-confirm-modal__title"
          >
            以下の報酬を受け取りました。
          </div>
          {listMissionConfirm?.map((mission) => (
            <div className="mission-confirm-modal__title" key={mission.id}>
              {mission.title}
            </div>
          ))}
        </div>
      );
    }
  };

  return (
    <Modal
      show={isShowConfirmModal}
      backdrop="static"
      keyboard={false}
      scrollable={true}
      onHide={handleCloseModal}
      centered
    >
      <Modal.Body
        style={{
          backgroundImage: `url(${backgroundConfirmModal})`,
          height: 'fit-content',
          padding: '30px',
        }}
      >
        <div className="mission-confirm-modal">
          {renderItem()}

          <Button
            className="mission-confirm-modal__btn"
            onClick={handleCloseModal}
          >
            OK
          </Button>
          <div className="mission-confirm-modal__description">
            ※獲得したギフトはギフトボックスの無料ギフトタブに格納されます。獲得したギフトには有効期限が存在します。先に獲得したギフトの有効期限が表示されます。
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LiveMissionConfirmGiftModal;
